module.exports = __webpack_public_path__ + "img/sw-face-md.63b9e6b5.webp";